import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ModalCloseButton from '../../shared/modalCloseButton/modalCloseButton';
import './ratingInfoCard.scss';

class RatingInfoCard extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id='rating' className='modal-content'>
                <ModalCloseButton placement='outer' />

                <div className="rate-info-container">
                    <div className='main-content'>
                        <header>
                            <h3>How our ratings work</h3>
                            <ModalCloseButton placement='inner' />
                        </header>

                        <p className='rate-info-desc'>
                            We considered six important standards and assigned a rating to each,
                            with 1 being the lowest score and 5 being the highest.
                            The Overall Rating for each diet is an average of these ratings.
                        </p>

                        <div className='rate-info-categories'>
                            <p>
                                <strong>Weight Loss or Weight Gain: </strong>
                                This rating considers how fast the diet will make you lose or gain weight,
                                whether the weight change can be sustained for 3 months or longer,
                                and whether the diet is a crash diet. A crash diet is a very low-calorie,
                                restrictive diet that comes with lots of health risks. Crash dieting can cause muscle loss,
                                a slowed metabolism, nutritional deficiencies, dizziness, and more. They’re not safe or healthy.
                            </p>
                            <p>
                                <strong>Healthy Eating Habits: </strong>
                                This rating considers whether the diet limits entire food groups,
                                and whether it disrupts your daily life with complex, specific requirements on what to eat or how to track your food.
                                It also considers whether the diet focuses on long-term lifestyle changes and encourages habits like eating more whole foods,
                                cooking at home, eating without distractions, etc.
                            </p>
                            <p>
                                <strong>Nutrition Quality: </strong>
                                This rating considers whether the diet is based on whole foods rather than processed ones.
                                It also considers whether the diet will cause nutrient deficiencies or a calorie deficiency
                                if you do it for longer than 2 to 3 months. Though you can add vitamin and mineral supplements
                                to any diet, it’s best to focus on getting what you need through a balanced diet.
                            </p>
                            <p>
                                <strong>Whole-Body Health: </strong>
                                This rating considers whether the diet sets unrealistic goals,
                                makes exaggerated claims, and promotes an unhealthy relationship with
                                food or appearance. It also considers whether the diet promotes exercise and
                                focuses on overall health rather than just weight. While you may have a weight-related goal you hope
                                to achieve through dieting, it’s important to nourish your body and make sure you’re staying healthy regardless of how you choose to eat.
                            </p>
                            <p>
                                <strong>Sustainability: </strong>
                                This rating considers how easy the diet is to follow, whether you can get support for it,
                                and if it can be maintained for 6 to 12 months or longer. It also takes cost into consideration,
                                since some diets require buying premade foods or paying membership fees.
                                Diets that are sustainable are more likely to be healthy in the long term. <a
                                    href='https://www.healthline.com/nutrition/yo-yo-dieting'
                                    target='_blank'>
                                    Yo-yo dieting 
                                </a> can contribute to health issues.
                            </p>
                            <p>
                                <strong>Evidence-Based: </strong>
                                This rating considers whether there’s evidence to support the diet’s health claims. We review scientific
                                research to see whether a diet has been clinically proven by impartial research.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => dispatch(closeModal())
    };
};


export default connect(null, mapDispatchToProps)(withRouter(RatingInfoCard));